module.exports = {"attributes":{"width":"42","height":"29","viewBox":"0 0 42 29","xmlns":"http://www.w3.org/2000/svg"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">     <rect fill=\"#FFF\" x=\"1\" width=\"39.5667\" height=\"29\" rx=\"3\"/>     <path d=\"M41.0404 26.0057c0 1.6537-1.348 2.9943-2.9956 2.9943H3.5218C1.8676 29 .5264 27.6532.5264 26.0057v-4.6373h40.514v4.6373z\" fill=\"#3C3C3C\"/>     <rect stroke=\"#CBD2DB\" x=\".5\" y=\".5\" width=\"40.2333\" height=\"28\" rx=\"3\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/generic_card.svg
// module id = 1413
// module chunks = 0